<template>
	<div class="w-full h-full px-4">
		<template v-if="providers.length > 0">
			<template v-if="filtered_templates.length > 0">
				<div
					v-for="template in filtered_templates"
					:key="template.id"
					class="w-full h-full"
				>
					<div
						v-if="can_modify"
						:id="'content_' + template.workgroup_schema"
						class="collapse w-full h-full m-0 b-0 p-0 show"
					>
						<div class="w-full h-full flex flex-wrap">
							<div class="w-full h-full flex gap-1">
								<!-- Area de exportacao -->
								<div
									class="w-6/12 h-full bg-light rounded-lg flex flex-col items-center justify-center"
								>
									<div
										class="w-11/12 select-card with-border my-2 py-1 px-2 mr-1"
										@click="OpenExportModal(template)"
									>
										<label class="">
											<div
												class="col rounded-lg d-flex justify-content-center"
											>
												<p
													class="mb-0 font-24 font-bold"
												>
													EXPORTAÇÕES
												</p>
											</div>
										</label>
									</div>
								</div>
								<!-- Area de importacao -->
								<div
									class="w-6/12 h-full ml-2 card bg-light rounded-lg border-no overflow-hidden"
								>
									<p
										class="my-2 text-center font-weight-bold text-dark font-20"
									>
										IMPORTAÇÕES
									</p>
									<div
										class="select-card with-border my-2 py-1 px-2 mr-1"
										@click="ImportTemplate(null, template)"
										:disabled="HasPendingProgress(template)"
									>
										<label class="">
											<div
												class="col rounded-lg d-flex justify-content-center"
											>
												<p class="mb-0">
													NOVA IMPORTAÇÃO
												</p>
											</div>
										</label>
									</div>
									<div style="height: 46vh; overflow: auto">
										<div
											class="mh-200 text-muted d-flex justify-content-center align-items-center"
											v-if="
												GetDataMovements(
													'i',
													template
												) == 0
											"
										>
											<span
												>Não há nenhum arquivo
												aqui</span
											>
										</div>
										<div
											v-for="data_movement in GetDataMovements(
												'i',
												template
											)"
											:key="data_movement.id"
										>
											<div
												class="border rounded-lg my-2 py-1 px-2"
											>
												<div
													class="col d-flex justify-content-between"
												>
													<span
														>IMPORTAÇÃO #{{
															data_movement.id
														}}</span
													>
													<span>{{
														ParseDate(
															data_movement.created_at
														)
													}}</span>
													<a
														class="px-1"
														v-tippy="{
															arrow: true,
														}"
														content="Fazer download"
														@click="
															DownloadFile(
																data_movement.url
															)
														"
														v-if="
															data_movement.url &&
															!data_movement.in_progress
														"
													>
														<i
															class="fa fa-download"
														></i>
													</a>
													<span
														v-tippy="{
															arrow: true,
														}"
														content="Arquivo na fila de processamento"
														v-else-if="
															data_movement.status ==
															'queued'
														"
													>
														<i
															class="fas fa-clock"
														></i>
													</span>
													<span
														v-tippy="{
															arrow: true,
														}"
														:content="
															'Importando os dados: ' +
															data_movement.progress_percentage +
															'%'
														"
														v-else-if="
															data_movement.status ==
															'executing'
														"
													>
														<span
															class="spinner-border spinner-border-sm mt-2"
															role="status"
															aria-hidden="true"
														></span>
													</span>
													<span
														v-tippy="{
															arrow: true,
														}"
														:content="
															GetDataMovementFailMessage(
																data_movement
															)
														"
														v-else-if="
															data_movement.status ==
																'failed' ||
															data_movement.status ==
																'retrying' ||
															(data_movement.status ==
																'finished' &&
																!data_movement.url)
														"
													>
														<i
															class="fas fa-exclamation-circle text-danger"
														></i>
													</span>
												</div>
											</div>
										</div>
									</div>
									<input
										type="file"
										name=""
										:id="'input-template' + template.id"
										accept=".xlsx"
										hidden
										@change="
											ImportTemplate($event, template)
										"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="border px-4 py-3 mt-3 rounded-lg">
					<div
						class="row justify-content-md-between align-items-center"
					>
						<div class="col mb-4 mb-md-0 text-center">
							Sua busca por "{{ search }}" retornou sem resultado.
						</div>
					</div>
				</div>
			</template>
		</template>

		<template v-else>
			<div class="border px-4 py-3 mt-3 rounded-lg">
				<div class="row justify-content-md-between align-items-center">
					<div class="col mb-4 mb-md-0 text-center">
						Não há templates para exibir.
					</div>
				</div>
			</div>
		</template>

		<ExportTemplateModal
			v-if="showExportTemplateModal"
			:data_movements="GetDataMovements('e', template)"
			@close="showExportTemplateModal = false"
			@export="HandleExport"
		/>
	</div>
</template>

<script>
	import _, { split } from 'lodash'
	import Helpers from '@/helpers'
	import moment from 'moment'
	import axios from 'axios'
	const helpers = new Helpers()
	import ExportTemplateModal from './components/ExportTemplateModal.vue'

	import Swal from 'sweetalert2'
	import { mapGetters, mapActions } from 'vuex'
	export default {
		name: 'Templates',
		components: {
			ExportTemplateModal,
		},
		props: {
			providers: {
				type: Array,
				default: () => [],
			},
			organization: {
				type: Object,
				default: () => {},
			},
			permission: {
				type: Boolean,
				default: false,
			},
			can_modify: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				search: '',
				mandatory: false,
				selected: {
					template: null,
				},
				exportOptions: {
					types: {},
					filters: {},
				},
				showExportTemplateModal: false,
				input_clickable: true,
			}
		},
		computed: {
			...mapGetters('auth', [
				'account',
				'requester_selected_id',
				'update_current_url',
			]),
			filtered_templates() {
				return this.providers.filter(provider => {
					return this.account.id == provider.account_provider_id
				})
			},
			template() {
				return this.providers.find(provider => {
					return this.account.id == provider.account_provider_id
				})
			},
			lib_schema() {
				return this.organization.instances[0].config.schema_name
			},
		},
		watch: {
			update_current_url: {
				handler(val) {
					if (val) {
						this.$emit('refresh-organization', false)

						this.UpdateCurrentUrl(false)

						this.$nextTick()
					}
				},
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			...mapActions('auth', ['UpdateCurrentUrl']),
			ConfirmDecision(type, template) {
				if (this.requester_selected_id != this.organization.id) {
					Swal.fire({
						icon: 'error',
						title: 'Logue nesta organização',
						text: 'Você precisa está logado nessa organização para fazer isso!',
					})
					return
				}

				Swal.fire({
					icon: 'question',
					title: `${
						type == 'set-default'
							? 'Definir como o padrão da organização'
							: 'Restaurar template ao padrão'
					}`,
					text: 'Esta ação é IRREVERSÍVEL e não poderá ser desfeita, deseja mesmo continuar?',
					showConfirmButton: true,
					showCancelButton: true,
					input: type == 'set-default' ? 'checkbox' : '',
					inputValue: this.mandatory,
					inputPlaceholder:
						'Atualização <b>obrigatória</b> para todos os membros da organização.',
					confirmButtonText: 'sim',
					cancelButtonText: 'não',
					customClass: {
						confirmButton: 'bg-danger',
					},
				}).then(async res => {
					if (res.isConfirmed) {
						switch (type) {
							case 'set-default':
								this.mandatory = res.value ? true : false

								this.SetDefault(template)
								break
							case 'restore-template':
								this.RestoreTemplate(template)
								break
						}
					}
				})
			},
			SetDefault(template) {
				this.StartLoading()

				const obj = {
					source: {
						account_id: template.account_requester_id,
						schema: template.workgroup_schema,
						provider_id: template.account_provider_id,
						type: 'WK',
					},
					options: {
						template: true,
						schedules_and_proceedings: false,
						configurations: false,
						flow: false,
					},
					destiny: {
						account_id: this.organization.id,
						schema: this.organization.instances[0].config
							.schema_name,
						type: 'PJ',
						only_set_default: true,
					},
					account_responsible_id: this.account.id,
					organization_id: this.requester_selected_id,
					mandatory: this.mandatory,
				}

				return window.api
					.call('post', '/set-default-template', obj)
					.then(({ data }) => {
						if (data.response) {
							Swal.fire({
								icon: 'success',
								title: 'Procedimento Concluido !',
								text: 'Template padrão setado com sucesso.',
							})
						} else {
							Swal.fire({
								icon: 'error',
								text: 'Houve um erro ao concluir, contate o suporte.',
								title: 'Eita!',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			RestoreTemplate(template) {
				this.StartLoading()

				const obj = {
					destiny: {
						account_id: template.account_requester_id,
						schema: template.workgroup_schema,
						provider_id: template.account_provider_id,
						type: 'WK',
						only_restore: true,
					},
					options: {
						template: true,
						schedules_and_proceedings: false,
						configurations: false,
						flow: false,
					},
					source: {
						account_id: this.organization.id,
						schema: this.organization.instances[0].config
							.schema_name,
						type: 'PJ',
					},
					account_responsible_id: this.account.id,
					organization_id: this.requester_selected_id,
				}

				return window.api
					.call('post', '/restore-from-default-template', obj)
					.then(({ data }) => {
						if (data.response) {
							Swal.fire({
								icon: 'success',
								title: 'Procedimento Concluido !',
								text: 'Template restaurado com sucesso.',
							})
						} else {
							Swal.fire({
								icon: 'error',
								text: 'Houve um erro ao concluir, contate o suporte.',
								title: 'Eita!',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			GetDataMovements(type, template) {
				return template.data_movements.filter(
					e => e.movement_type == type
				)
			},
			ParseDate(date) {
				return moment(date).format('DD/MM/YYYY HH:mm')
			},
			HasPendingProgress(template) {
				let pendings = template.data_movements.filter(
					e => e.status == 'queued' || e.status == 'executing'
				)

				return pendings.length > 0
			},
			DownloadFile(url) {
				const method = 'GET'

				this.StartLoading()

				axios
					.request({
						url,
						method,
						responseType: 'blob',
					})
					.then(({ data }) => {
						const downloadUrl = window.URL.createObjectURL(
							new Blob([data], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							})
						)
						const link = document.createElement('a')
						link.href = downloadUrl
						// let filename = (split(url, '/')[6] + '.xlsx')
						link.setAttribute('download', '')
						document.body.appendChild(link)
						link.click()
						link.remove()
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			OpenExportModal(template) {
				this.selected.template = template
				this.showExportTemplateModal = true
			},
			HandleExport(exportOptions) {
				this.exportOptions = { ...exportOptions }

				this.ExportTemplate()
			},
			ExportTemplate() {
				const template = this.selected.template

				if (this.HasPendingProgress(template)) {
					return Swal.fire({
						icon: 'info',
						toast: true,
						timer: 5000,
						position: 'top',
						html: 'Um procedimento já em andamento, aguarde.',
					})
				}

				this.StartLoading()

				return window.api
					.call('post', '/data-movement/export/template', {
						schema: template.workgroup_schema,
						account_workgroup_id: template.id,
						options: this.exportOptions,
					})
					.then(({ data }) => {
						if (!data.response) {
							Swal.fire({
								icon: 'error',
								text: data.message,
								title: 'Ops!',
							})
						} else {
							if (data.pending_laudos > 0) {
								Swal.fire({
									icon: 'warning',
									text: `A importação ${data.data_movement.id} foi para a fila de processamento. Porém, esse template possui ${data.pending_laudos} laudos em abertos, e não será possível importar caso haja laudos em aberto.`,
								})
							} else {
								Swal.fire({
									icon: 'info',
									title: 'Em andamento...',
									toast: true,
									position: 'top',
									html: `${data.message}`,
								})
							}

							this.$emit('refresh-organization')
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			ImportTemplate(event, template) {
				if (this.HasPendingProgress(template)) {
					return Swal.fire({
						icon: 'info',
						toast: true,
						timer: 5000,
						position: 'top',
						html: 'Um procedimento já em andamento, aguarde.',
					})
				}

				if (event && event.target.files.length > 0) {
					const file = event.target.files[0]

					this.StartLoading()

					const formData = new FormData()

					formData.append('file', file, file.name)
					formData.append('schema', template.workgroup_schema)
					formData.append('lib_schema', this.lib_schema)

					return window.api
						.call(
							'post',
							'/data-movement/import/template',
							formData
						)
						.then(({ data }) => {
							if (!data.response) {
								Swal.fire({
									icon: 'error',
									text: data.message,
									title: 'Ops!',
								})
							} else {
								Swal.fire({
									icon: 'info',
									toast: true,
									position: 'top',
									timer: 5000,
									text: `A importação ${data.data_movement.id} foi para a fila de processamento.`,
									timerProgressBar: true,
								})

								this.$emit('refresh-organization')
							}

							document.querySelector(
								'#input-template' + template.id
							).value = null
						})
						.finally(() => {
							this.FinishLoading()
						})
				}

				if (!this.input_clickable) return

				document.querySelector('#input-template' + template.id).click()
			},
			GetDataMovementFailMessage(data_movement) {
				if (data_movement?.job_status?.output?.message) {
					return (
						data_movement.job_status.output.message.substring(
							0,
							100
						) + '...'
					)
				}

				return 'Não foi possível importar.'
			},
		},
	}
</script>

<style lang="scss" scoped>
	.mh-138 {
		height: 138px;
		overflow: auto;
	}

	.fa-download {
		cursor: pointer;
	}

	.select-card label {
		padding-right: 1.5rem !important;
	}
</style>
